/*
 * @Author: Ximen
 * @Date: 2021-04-02 15:49:05
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-13 15:06:22
 */
import { createStore } from 'vuex';

export default createStore({
  state: {
    isShowGoBack: true,
    isNew: 0,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
